import { render, staticRenderFns } from "./PracticeSubmission.vue?vue&type=template&id=108f82e5&scoped=true"
import script from "./PracticeSubmission.vue?vue&type=script&lang=js"
export * from "./PracticeSubmission.vue?vue&type=script&lang=js"
import style0 from "./PracticeSubmission.vue?vue&type=style&index=0&id=108f82e5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "108f82e5",
  null
  
)

export default component.exports